// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"88":"4b90892e","223":"e955a083","563":"40fc4d20","574":"a67a2bc6"}[chunkId] + ".chunk.js");